export default {
  state: {
    now: Date.now(),
    serverNow: Date.now(),
    clock: 0, // 定时器
    offsetTime: 0, // 时间偏移量
  },
}
